import $ from 'jquery';
import * as CONST from '../utils/constants';

class JumpTo {
    constructor() {
    }

    init() {
        this.bindEvents();
    }

    bindEvents() {
        $('.jump-to-container-anchor').click((event) => {
            const dest = $(event.target).attr('href');
            $('html, body').animate({
                scrollTop: $(dest).offset().top - 150
            }, 1000);
        });

        $('.jump-link a').click((event) => {
            const dest = $(event.target).attr('href');
            $('html, body').animate({
                scrollTop: $(dest).offset().top - 150
            }, 1000);
        });
    }
}

export default JumpTo;